import { VideoDto } from 'client/types';

/**
 * Ordena la lista de videos, colocando el indice seleccionado primero
 * @param videos
 * @param startIndex
 */
export const orderVideos = (videos: VideoDto[], startIndex: number) => {
  return videos
    .map((value, idx) => ({ value, idx }))
    .sort((a, b) => {
      if (a.idx === startIndex) {
        return -1;
      }
      if (b.idx === startIndex) {
        return 1;
      }
      return a.idx - b.idx;
    })
    .map(({ value }) => value);
};
